var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "scan_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c("div", { staticClass: "tips" }, [
        _vm._v(" 支持PNG、JPG等格式，2M以内，建议尺寸为750*150 "),
      ]),
      _c("el-form-item", { attrs: { prop: "imageurl" } }, [
        _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "upload-item-wrap" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("upload-file", {
                  ref: "uploadBanner",
                  attrs: {
                    "link-url": _vm.linkUrl,
                    tempurl: _vm.value.config.imageurl,
                    canDel: Boolean(_vm.value.config.imageurl),
                    deletePadding: true,
                    uploadInfo: _vm.uploadInfo,
                  },
                  on: {
                    onDelete: _vm.deleteImg,
                    emitUploadFile: _vm.emitUploadFile,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("el-button", { on: { click: _vm.upload } }, [
                  _vm._v("上传图片"),
                ]),
                _vm.pictureList.length > 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.selectPicture },
                      },
                      [_vm._v("选择图片")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "bind_card_mode",
            rules: [
              {
                required: true,
                message: "请选择默认绑卡方式",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v("默认绑卡模式：")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.bind_card_mode,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "bind_card_mode", $$v)
                },
                expression: "value.config.bind_card_mode",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("扫码绑卡")]),
              _c("el-radio", { attrs: { label: 2 } }, [_vm._v("卡号密码绑卡")]),
            ],
            1
          ),
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 当组件选中【扫码绑卡】模式，点击组件调用系统的扫一扫绑卡功能；组件选中【卡号密码绑卡】模式，点击组件进入输入卡号密码绑卡页，也可点击页面扫码添加按钮调起扫一扫绑卡。 "
            ),
          ]),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }